(() => {
  document.documentElement.classList.remove('no-js');

  document.querySelectorAll('[data-ttc-menu-button]').forEach((button) => {
    const header = button.closest('header');
    const menu = [...(header?.parentElement?.children || [])].find((element) => element.matches('[data-ttc-menu]'));
    if (!menu) return;
    const close = menu.querySelector('[data-ttc-menu-close]');
    const openMenu = () => {
      menu.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      document.body.classList.add('menu-open');
      close?.focus();
    };
    const closeMenu = () => {
      menu.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
      button.focus();
    };
    button.addEventListener('click', openMenu);
    close?.addEventListener('click', closeMenu);
    menu.addEventListener('click', (event) => { if (event.target === menu) closeMenu(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !menu.hidden) closeMenu(); });
  });

  document.querySelectorAll('[data-ttc-hero]').forEach((hero) => {
    const image = hero.querySelector('[data-ttc-hero-image]');
    const title = hero.querySelector('[data-ttc-hero-title]');
    const eyebrow = hero.querySelector('[data-ttc-hero-eyebrow]');
    const choices = [...hero.querySelectorAll('[data-ttc-hero-choice]')];
    if (!image || !title || !eyebrow) return;
    const defaults = { image: hero.dataset.defaultImage, title: title.textContent, eyebrow: eyebrow.textContent };
    choices.forEach((choice) => { const preload = new Image(); preload.src = choice.dataset.image; });
    const activate = (choice) => {
      if (window.matchMedia('(max-width: 760px)').matches) return;
      image.style.opacity = '.35';
      window.setTimeout(() => { image.src = choice.dataset.image; image.style.opacity = '1'; }, 120);
      title.textContent = choice.dataset.title;
      eyebrow.textContent = choice.dataset.eyebrow;
    };
    const reset = () => {
      if (window.matchMedia('(max-width: 760px)').matches) return;
      image.src = defaults.image;
      image.style.opacity = '1';
      title.textContent = defaults.title;
      eyebrow.textContent = defaults.eyebrow;
    };
    choices.forEach((choice) => {
      choice.addEventListener('mouseenter', () => activate(choice));
      choice.addEventListener('focus', () => activate(choice));
    });
    hero.querySelector('.ttc-hero-choices')?.addEventListener('mouseleave', reset);
    hero.addEventListener('focusout', (event) => { if (!hero.contains(event.relatedTarget)) reset(); });
  });

  document.querySelectorAll('[data-ttc-search-overlay]').forEach((overlay) => {
    const header = overlay.previousElementSibling;
    const openButton = header?.querySelector('[data-ttc-search-open]');
    const closeButton = overlay.querySelector('[data-ttc-search-close]');
    const input = overlay.querySelector('[data-ttc-search-input]');
    const suggestions = overlay.querySelector('[data-ttc-search-suggestions]');

    const openSearch = () => {
      overlay.hidden = false;
      openButton?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('search-open');
      window.requestAnimationFrame(() => input?.focus());
    };
    const closeSearch = () => {
      overlay.hidden = true;
      openButton?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('search-open');
      if (input) {
        input.value = '';
        input.setAttribute('aria-expanded', 'false');
      }
      if (suggestions) suggestions.hidden = true;
      openButton?.focus();
    };

    openButton?.addEventListener('click', openSearch);
    closeButton?.addEventListener('click', closeSearch);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !overlay.hidden) closeSearch();
    });
  });

  document.querySelectorAll('[data-ttc-predictive-search]').forEach((form) => {
    const input = form.querySelector('[data-ttc-search-input]');
    const suggestions = form.querySelector('[data-ttc-search-suggestions]');
    const results = [...form.querySelectorAll('[data-ttc-search-result]')];
    const empty = form.querySelector('[data-ttc-search-empty]');
    let activeIndex = -1;

    const closeSuggestions = () => {
      if (suggestions) suggestions.hidden = true;
      input?.setAttribute('aria-expanded', 'false');
      results.forEach((result) => result.classList.remove('is-active'));
      activeIndex = -1;
    };

    const getSearchScore = (result, term) => {
      const title = result.querySelector('strong')?.textContent.trim().toLocaleLowerCase() || '';
      const titleWords = title.split(/\s+/).filter(Boolean);
      const keywords = (result.dataset.searchTerms || '').toLocaleLowerCase();
      const keywordWords = keywords.split(/\s+/).filter(Boolean);
      const priority = Number.parseInt(result.dataset.searchPriority || '9', 10);
      const originalIndex = results.indexOf(result);

      let matchRank = 99;
      if (title.startsWith(term)) matchRank = 0;
      else if (titleWords.some((word) => word.startsWith(term))) matchRank = 1;
      else if (keywordWords.some((word) => word.startsWith(term))) matchRank = 2;
      else if (title.includes(term)) matchRank = 3;
      else if (keywords.includes(term)) matchRank = 4;

      return (matchRank * 10000) + (priority * 100) + originalIndex;
    };

    const updateSuggestions = () => {
      const term = input?.value.trim().toLocaleLowerCase() || '';
      if (!term) {
        closeSuggestions();
        return;
      }

      const matchedResults = results
        .filter((result) => {
          const title = result.querySelector('strong')?.textContent.trim().toLocaleLowerCase() || '';
          const keywords = (result.dataset.searchTerms || '').toLocaleLowerCase();
          return title.includes(term) || keywords.includes(term);
        })
        .sort((a, b) => getSearchScore(a, term) - getSearchScore(b, term));

      results.forEach((result) => { result.hidden = !matchedResults.includes(result); });
      matchedResults.forEach((result) => suggestions?.insertBefore(result, empty || null));

      if (empty) empty.hidden = matchedResults.length > 0;
      if (suggestions) suggestions.hidden = false;
      input?.setAttribute('aria-expanded', 'true');
      activeIndex = -1;
    };

    input?.addEventListener('input', updateSuggestions);
    input?.addEventListener('focus', () => { if (input.value.trim()) updateSuggestions(); });
    input?.addEventListener('keydown', (event) => {
      const visibleResults = results.filter((result) => !result.hidden);
      if (event.key === 'Escape') {
        closeSuggestions();
        return;
      }
      if (!visibleResults.length || (event.key !== 'ArrowDown' && event.key !== 'ArrowUp' && event.key !== 'Enter')) return;
      if (event.key === 'Enter' && activeIndex >= 0) {
        event.preventDefault();
        window.location.href = visibleResults[activeIndex].href;
        return;
      }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        activeIndex = event.key === 'ArrowDown'
          ? (activeIndex + 1) % visibleResults.length
          : (activeIndex - 1 + visibleResults.length) % visibleResults.length;
        visibleResults.forEach((result, index) => result.classList.toggle('is-active', index === activeIndex));
        visibleResults[activeIndex]?.scrollIntoView({ block: 'nearest' });
      }
    });
    form.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (!form.contains(document.activeElement)) {
          closeSuggestions();
        }
      }, 100);
    });
    document.addEventListener('click', (event) => { if (!form.contains(event.target)) closeSuggestions(); });
  });

  document.querySelectorAll('[data-ttc-language-selector]').forEach((selector) => {
    selector.addEventListener('change', () => selector.form?.submit());
  });

  document.querySelectorAll('[data-ttc-tour-booking]').forEach((booking) => {
    const monthLabel = booking.querySelector('[data-ttc-calendar-month]');
    const weekdays = booking.querySelector('[data-ttc-calendar-weekdays]');
    const days = booking.querySelector('[data-ttc-calendar-days]');
    const previous = booking.querySelector('[data-ttc-calendar-previous]');
    const next = booking.querySelector('[data-ttc-calendar-next]');
    const selectedDateInput = booking.querySelector('[data-ttc-tour-selected-date]');
    const timeInputs = [...booking.querySelectorAll('input[name="tour_time"]')];
    const summary = booking.querySelector('[data-ttc-tour-selection]');
    const continueButton = booking.querySelector('[data-ttc-tour-continue]');
    const placeholder = summary?.textContent || '';
    const locale = document.documentElement.lang || 'en-GB';
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    let cursor = new Date(today.getFullYear(), today.getMonth(), 1);
    let selectedDate = null;

    const toLocalIso = (date) => [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-');
    const formatFullDate = (date) => new Intl.DateTimeFormat(locale, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }).format(date);
    const selectedTime = () => timeInputs.find((input) => input.checked);

    const updateSelection = () => {
      const time = selectedTime();
      const complete = Boolean(selectedDate && time);
      if (continueButton) continueButton.disabled = !complete;
      if (summary) {
        summary.textContent = complete
          ? `${booking.dataset.selectionPrefix}: ${formatFullDate(selectedDate)}, ${time.nextElementSibling?.textContent || time.value}`
          : placeholder;
      }
    };

    const renderCalendar = () => {
      if (!days || !monthLabel) return;
      monthLabel.textContent = new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric' }).format(cursor);
      previous.disabled = cursor.getFullYear() === today.getFullYear() && cursor.getMonth() === today.getMonth();
      days.replaceChildren();
      const firstDay = new Date(cursor.getFullYear(), cursor.getMonth(), 1);
      const leadingBlanks = (firstDay.getDay() + 6) % 7;
      for (let index = 0; index < leadingBlanks; index += 1) {
        const blank = document.createElement('span');
        blank.setAttribute('aria-hidden', 'true');
        days.appendChild(blank);
      }
      const numberOfDays = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 0).getDate();
      for (let day = 1; day <= numberOfDays; day += 1) {
        const date = new Date(cursor.getFullYear(), cursor.getMonth(), day);
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = String(day);
        button.disabled = date < today;
        button.setAttribute('aria-label', formatFullDate(date));
        if (selectedDate && toLocalIso(date) === toLocalIso(selectedDate)) {
          button.classList.add('is-selected');
          button.setAttribute('aria-pressed', 'true');
        } else {
          button.setAttribute('aria-pressed', 'false');
        }
        button.addEventListener('click', () => {
          selectedDate = date;
          if (selectedDateInput) selectedDateInput.value = toLocalIso(date);
          renderCalendar();
          updateSelection();
        });
        days.appendChild(button);
      }
    };

    if (weekdays) {
      const monday = new Date(2024, 0, 1);
      for (let index = 0; index < 7; index += 1) {
        const label = document.createElement('span');
        const date = new Date(monday);
        date.setDate(monday.getDate() + index);
        label.textContent = new Intl.DateTimeFormat(locale, { weekday: 'short' }).format(date).replace('.', '');
        weekdays.appendChild(label);
      }
    }

    previous?.addEventListener('click', () => {
      if (previous.disabled) return;
      cursor = new Date(cursor.getFullYear(), cursor.getMonth() - 1, 1);
      renderCalendar();
    });
    next?.addEventListener('click', () => {
      cursor = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 1);
      renderCalendar();
    });
    timeInputs.forEach((input) => input.addEventListener('change', updateSelection));
    continueButton?.addEventListener('click', () => {
      const time = selectedTime();
      if (!selectedDate || !time) return;
      const formattedDate = formatFullDate(selectedDate);
      const formattedTime = time.nextElementSibling?.textContent || time.value;
      const contactTour = document.querySelector('[data-ttc-contact-tour]');
      const contactDate = document.querySelector('[data-ttc-contact-date]');
      const contactTime = document.querySelector('[data-ttc-contact-time]');
      const contactSummary = document.querySelector('[data-ttc-contact-tour-summary]');
      if (contactTour) contactTour.value = booking.dataset.tourName;
      if (contactDate) contactDate.value = selectedDateInput?.value || toLocalIso(selectedDate);
      if (contactTime) contactTime.value = time.value;
      if (contactSummary) {
        contactSummary.textContent = `${booking.dataset.tourName} — ${formattedDate}, ${formattedTime}`;
        contactSummary.hidden = false;
      }
    });

    renderCalendar();
    updateSelection();
  });

  // Keep the visible tour duration, Shopify variants and booking-app line-item
  // properties in step with one another. Language is collected by the booking app.
  document.querySelectorAll('[data-ttc-tour-options]').forEach((configurator) => {
    const bookingHost = document.getElementById(configurator.dataset.bookingHost);
    const durationSelect = configurator.querySelector('[data-ttc-tour-duration]');
    const price = configurator.querySelector('[data-ttc-tour-price]');
    const availability = configurator.querySelector('[data-ttc-tour-availability]');
    const variantsSource = configurator.querySelector('[data-ttc-tour-variants]');
    let variants = [];

    try {
      variants = variantsSource ? JSON.parse(variantsSource.textContent) : [];
    } catch (error) {
      variants = [];
    }

    const normalise = (value) => String(value || '').trim().toLocaleLowerCase();
    const selectedValues = () => [durationSelect?.value].filter(Boolean).map(normalise);
    const findVariant = () => {
      if (variants.length === 1) return variants[0];
      const choices = selectedValues();
      return variants.find((variant) => {
        const options = [variant.option1, variant.option2, variant.option3].filter(Boolean).map(normalise);
        return choices.every((choice) => options.includes(choice));
      });
    };
    const setProperty = (form, name, value) => {
      if (!value) return;
      let input = [...form.querySelectorAll('input[type="hidden"]')].find((candidate) => candidate.name === `properties[${name}]`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${name}]`;
        form.appendChild(input);
      }
      input.value = value;
    };
    const syncBookingHost = (variant) => {
      if (!bookingHost) return;
      bookingHost.dataset.selectedVariantId = variant?.id || '';
      bookingHost.querySelectorAll('form').forEach((form) => {
        if (variant?.id) {
          form.querySelectorAll('input[name="id"], input[name="variant_id"], select[name="id"], select[name="variant_id"]').forEach((control) => {
            if (String(control.value) !== String(variant.id)) {
              control.value = String(variant.id);
              control.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        }
        setProperty(form, 'Duration', durationSelect?.value);
      });
    };
    const update = () => {
      const variant = findVariant();
      if (price) {
        const hours = Number(durationSelect?.selectedOptions[0]?.dataset.hours || 3);
        price.textContent = variant?.priceText || `CHF ${250 + Math.max(0, hours - 3) * 100}`;
        const factPrice = configurator.closest('.ttc-tour-detail__copy')?.querySelector('[data-ttc-guide-fact-price]');
        if (factPrice) factPrice.textContent = price.textContent;
      }
      if (availability) availability.hidden = !(variant && variant.available === false);
      syncBookingHost(variant);
    };

    durationSelect?.addEventListener('change', update);
    bookingHost?.addEventListener('click', update, true);
    if (bookingHost) new MutationObserver(update).observe(bookingHost, { childList: true, subtree: true });
    update();
  });

  document.querySelectorAll('[data-ttc-tour-overlay]').forEach((overlay) => {
    const overlayName = overlay.dataset.ttcTourOverlay;
    const panel = overlay.querySelector('[data-ttc-tour-overlay-panel]');
    const openButtons = [...document.querySelectorAll(`[data-ttc-tour-overlay-open="${overlayName}"]`)];
    let returnFocus = null;

    const openOverlay = (trigger) => {
      returnFocus = trigger;
      overlay.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('modal-open');
      window.requestAnimationFrame(() => panel?.focus());
    };

    const closeOverlay = (restoreFocus = true, preserveBodyLock = false) => {
      overlay.hidden = true;
      returnFocus?.setAttribute('aria-expanded', 'false');
      if (!preserveBodyLock) document.body.classList.remove('modal-open');
      if (restoreFocus) returnFocus?.focus();
    };

    openButtons.forEach((button) => button.addEventListener('click', () => openOverlay(button)));
    overlay.querySelectorAll('[data-ttc-tour-overlay-close]').forEach((button) => {
      button.addEventListener('click', () => closeOverlay());
    });
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) closeOverlay();
      if (event.target.closest('[data-ttc-tour-continue]')) closeOverlay(false, true);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !overlay.hidden) closeOverlay();
    });
  });

  const contactModal = document.querySelector('[data-ttc-contact-modal]');
  if (contactModal) {
    const panel = contactModal.querySelector('[data-ttc-contact-panel]');
    let returnFocus = null;

    const openContact = (trigger) => {
      const menu = trigger.closest('[data-ttc-menu]');
      returnFocus = menu ? document.querySelector('[data-ttc-menu-button]') : trigger;
      if (menu) {
        menu.hidden = true;
        document.body.classList.remove('menu-open');
        document.querySelectorAll('[data-ttc-menu-button]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
      }
      if (!trigger.hasAttribute('data-ttc-tour-request-trigger')) {
        const tour = contactModal.querySelector('[data-ttc-contact-tour]');
        const date = contactModal.querySelector('[data-ttc-contact-date]');
        const time = contactModal.querySelector('[data-ttc-contact-time]');
        const summary = contactModal.querySelector('[data-ttc-contact-tour-summary]');
        if (tour) tour.value = '';
        if (date) date.value = '';
        if (time) time.value = '';
        if (summary) summary.hidden = true;
      }
      contactModal.hidden = false;
      document.body.classList.add('modal-open');
      window.requestAnimationFrame(() => panel?.focus());
    };

    const closeContact = () => {
      contactModal.hidden = true;
      document.body.classList.remove('modal-open');
      returnFocus?.focus();
    };

    document.querySelectorAll('[data-ttc-contact-open]').forEach((trigger) => {
      trigger.addEventListener('click', () => openContact(trigger));
    });
    contactModal.querySelectorAll('[data-ttc-contact-close]').forEach((button) => button.addEventListener('click', closeContact));
    contactModal.addEventListener('click', (event) => { if (event.target === contactModal) closeContact(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !contactModal.hidden) closeContact(); });

    if (contactModal.hasAttribute('data-ttc-contact-auto-open')) {
      contactModal.hidden = false;
      document.body.classList.add('modal-open');
      window.requestAnimationFrame(() => panel?.focus());
    }
  }

  document.querySelectorAll('.ttc-form__success').forEach((message) => message.focus());

  document.querySelectorAll('[data-ttc-required-group]').forEach((group) => {
    const checkboxes = [...group.querySelectorAll('input[type="checkbox"]')];
    const validationControl = checkboxes[0];
    const error = group.querySelector('[data-ttc-group-error]');
    if (!validationControl) return;

    const validate = () => {
      const valid = checkboxes.some((checkbox) => checkbox.checked);
      validationControl.setCustomValidity(valid ? '' : (group.dataset.validationMessage || 'Please select at least one interest.'));
      group.classList.toggle('is-invalid', !valid && !error?.hidden);
      if (valid && error) error.hidden = true;
    };

    checkboxes.forEach((checkbox) => checkbox.addEventListener('change', validate));
    validationControl.addEventListener('invalid', () => {
      if (error) error.hidden = false;
      group.classList.add('is-invalid');
    });
    validate();
  });

  document.querySelectorAll('[data-ttc-date-range]').forEach((range) => {
    const trigger = range.querySelector('[data-ttc-date-trigger]');
    const popover = range.querySelector('[data-ttc-date-popover]');
    const start = range.querySelector('[data-ttc-date-start]');
    const end = range.querySelector('[data-ttc-date-end]');
    const summary = range.querySelector('[data-ttc-date-summary]');
    const placeholder = summary?.textContent || '';

    const formatDate = (value) => {
      if (!value) return '';
      return new Intl.DateTimeFormat(document.documentElement.lang || 'en-GB', {
        day: 'numeric', month: 'short', year: 'numeric'
      }).format(new Date(`${value}T12:00:00`));
    };
    const updateRange = () => {
      if (start?.value) end.min = start.value;
      else end?.removeAttribute('min');
      if (end?.value) start.max = end.value;
      else start?.removeAttribute('max');
      if (start?.value && end?.value && end.value < start.value) end.value = '';
      const value = [formatDate(start?.value), formatDate(end?.value)].filter(Boolean).join(' — ');
      if (summary) summary.textContent = value || placeholder;
      trigger?.classList.toggle('has-value', Boolean(value));
    };
    const closeRange = () => {
      if (popover) popover.hidden = true;
      trigger?.setAttribute('aria-expanded', 'false');
    };
    const openRange = () => {
      document.querySelectorAll('[data-ttc-date-popover]').forEach((other) => { if (other !== popover) other.hidden = true; });
      if (popover) popover.hidden = false;
      trigger?.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(() => start?.focus());
    };
    trigger?.addEventListener('click', () => popover?.hidden ? openRange() : closeRange());
    start?.addEventListener('change', updateRange);
    end?.addEventListener('change', updateRange);
    range.querySelector('[data-ttc-date-done]')?.addEventListener('click', closeRange);
    document.addEventListener('click', (event) => { if (!range.contains(event.target)) closeRange(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !popover?.hidden) closeRange(); });
    updateRange();
  });

  document.querySelectorAll('[data-ttc-filter-catalogue]').forEach((catalogue) => {
    const buttons = [...catalogue.querySelectorAll('[data-ttc-filter-button]')];
    const items = [...catalogue.querySelectorAll('[data-ttc-filter-item]')];
    const empty = catalogue.querySelector('[data-ttc-filter-empty]');
    const count = catalogue.querySelector('[data-ttc-filter-count]');
    const showing = catalogue.querySelector('[data-ttc-filter-showing]');

    const updateCatalogue = () => {
      const selected = {};
      buttons.forEach((button) => {
        if (button.getAttribute('aria-pressed') === 'true') selected[button.dataset.filterGroup] = button.dataset.filterValue;
      });

      let visibleCount = 0;
      items.forEach((item) => {
        const isVisible = Object.entries(selected).every(([group, value]) => {
          if (value === 'all') return true;
          return (item.dataset[group] || '').split(' ').includes(value);
        });
        item.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      if (empty) empty.hidden = visibleCount !== 0;
      if (count) {
        const noun = visibleCount === 1 ? count.dataset.singular : count.dataset.plural;
        count.textContent = `${visibleCount} ${noun}`;
      }
      if (showing) showing.textContent = `${showing.dataset.prefix} ${visibleCount}`;
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons
          .filter((candidate) => candidate.dataset.filterGroup === button.dataset.filterGroup)
          .forEach((candidate) => {
            const isSelected = candidate === button;
            candidate.setAttribute('aria-pressed', String(isSelected));
            candidate.classList.toggle('is-selected', isSelected);
          });
        updateCatalogue();
      });
    });

    catalogue.querySelectorAll('[data-ttc-filter-reset]').forEach((reset) => {
      reset.addEventListener('click', () => {
        buttons.forEach((button) => {
          const isSelected = button.dataset.filterValue === 'all';
          button.setAttribute('aria-pressed', String(isSelected));
          button.classList.toggle('is-selected', isSelected);
        });
        updateCatalogue();
      });
    });

    updateCatalogue();
  });

  // Privacy-first Google Maps embeds. The Google iframe is not created and no
  // request is sent to Google until the visitor explicitly chooses to load it.
  document.querySelectorAll('[data-ttc-google-map]').forEach((container) => {
    const loadButton = container.querySelector('[data-ttc-google-map-load]');
    if (!loadButton) return;

    loadButton.addEventListener('click', () => {
      const src = loadButton.dataset.mapSrc;
      if (!src || container.dataset.loaded === 'true') return;

      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.title = loadButton.dataset.mapTitle || 'Interactive map';
      iframe.loading = 'lazy';
      iframe.referrerPolicy = 'no-referrer';
      iframe.allowFullscreen = true;
      iframe.setAttribute('width', '1000');
      iframe.setAttribute('height', '620');

      container.dataset.loaded = 'true';
      container.replaceChildren(iframe);
    });
  });

  document.querySelectorAll('[data-ttc-cookie-preferences]').forEach((button) => {
    button.addEventListener('click', async (event) => {
      event.preventDefault();

      const fallbackUrl = button.dataset.fallbackUrl || '/policies/privacy-policy';

      // Shopify's native cookie banner exposes the preferences modal through
      // the global privacyBanner object. This re-opens the same granular
      // Required / Personalization / Marketing / Analytics preferences panel
      // that Shopify displays from Customer privacy settings.
      const openPreferences = () => {
        if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
          try {
            const result = window.privacyBanner.showPreferences();
            if (result && typeof result.catch === 'function') {
              result.catch(() => { window.location.href = fallbackUrl; });
            }
            return true;
          } catch (error) {
            return false;
          }
        }
        return false;
      };

      if (openPreferences()) return;

      // The Shopify privacy script can load asynchronously. Give it a short
      // moment before falling back to the Privacy Policy page.
      let attempts = 0;
      const timer = window.setInterval(() => {
        attempts += 1;
        if (openPreferences()) {
          window.clearInterval(timer);
          return;
        }
        if (attempts >= 10) {
          window.clearInterval(timer);
          window.location.href = fallbackUrl;
        }
      }, 150);
    });
  });

  const successModal = document.querySelector('[data-ttc-success-modal]');
  if (successModal) {
    document.body.classList.add('modal-open');
    window.requestAnimationFrame(() => successModal.querySelector('[data-ttc-success-panel]')?.focus());
  }

  // Keep the header cart count fresh when customers return from booking/checkout flows.
  window.addEventListener('pageshow', () => {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then((response) => response.ok ? response.json() : null)
      .then((cart) => {
        if (!cart) return;
        document.querySelectorAll('.ttc-cart-link').forEach((link) => {
          let badge = link.querySelector('.ttc-cart-link__count');
          if (cart.item_count > 0) {
            if (!badge) { badge = document.createElement('span'); badge.className = 'ttc-cart-link__count'; link.appendChild(badge); }
            badge.textContent = String(cart.item_count);
          } else if (badge) { badge.remove(); }
        });
      })
      .catch(() => {});
  });


  // v27: Easy Appointment Booking's native Popup Calendar Button is the source of truth.
  // The Lugano page now renders through its JSON template so this app block can actually exist.
  // The large Ceresio "Select a date and time" card simply triggers that native
  // app block, so the calendar overlay is opened and managed by Servicify itself.
  document.querySelectorAll('[data-ttc-native-booking-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      const host = document.querySelector('[data-ttc-native-booking-host]');
      if (!host) return;
      const nativeButton = host.querySelector('.shopify-app-block button, .shopify-app-block a, .shopify-app-block [role="button"], button, a, [role="button"]');
      if (nativeButton && nativeButton !== trigger) {
        event.preventDefault();
        nativeButton.click();
      }
    });
  });

  // Keep the app-controlled CTA aligned with the Ceresio wording, including
  // buttons inserted after load by Easy Appointment Booking.
  document.querySelectorAll('[data-ttc-native-booking-host]').forEach((host) => {
    const tidyBookButtonLabel = () => {
      host.querySelectorAll('button, a, [role="button"]').forEach((control) => {
        if (!/^book this tour\.\s*$/i.test(control.textContent.trim())) return;
        const walker = document.createTreeWalker(control, NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) {
          walker.currentNode.nodeValue = walker.currentNode.nodeValue.replace(/(book this tour)\.(\s*)$/i, '$1$2');
        }
      });
    };
    tidyBookButtonLabel();
    new MutationObserver(tidyBookButtonLabel).observe(host, { childList: true, subtree: true, characterData: true });
  });

      // Show only the booking block matching the selected duration.
  const setupDurationSwitcher = () => {
    document
      .querySelectorAll('[data-ttc-tour-options][data-mode="flexible"]')
      .forEach((configurator) => {
        if (configurator.dataset.durationSwitcherReady === 'true') return;

        const host = document.getElementById(
          configurator.dataset.bookingHost
        );
        const durationSelect = configurator.querySelector(
          '[data-ttc-tour-duration]'
        );

        if (!host || !durationSelect) return;

        configurator.dataset.durationSwitcherReady = 'true';

        const update = () => {
          const hours = String(
            durationSelect.selectedOptions[0]?.dataset.hours ||
              durationSelect.value.match(/\d+/)?.[0] ||
              '3'
          );

          const blocks = new Map();

          host
            .querySelectorAll('[class*="ttc-booking-duration-"]')
            .forEach((element) => {
              const durationClass = [...element.classList].find((name) =>
                /^ttc-booking-duration-(3|4|5|6|7|8)$/.test(name)
              );

              if (!durationClass) return;

              const block =
                element.closest('.shopify-app-block') ||
                element.closest('[id^="shopify-block-"]') ||
                element;

              if (block && host.contains(block)) {
                blocks.set(block, durationClass);
              }
            });

          blocks.forEach((durationClass, block) => {
            const visible =
              durationClass === `ttc-booking-duration-${hours}`;

            block.hidden = !visible;
            block.setAttribute(
              'aria-hidden',
              visible ? 'false' : 'true'
            );

            if (visible) {
              block.style.removeProperty('display');
            } else {
              block.style.setProperty(
                'display',
                'none',
                'important'
              );
            }
          });
        };

        durationSelect.addEventListener('change', update);
        update();

        new MutationObserver(update).observe(host, {
          childList: true,
          subtree: true
        });
      });
  };

  setupDurationSwitcher();
  document.addEventListener(
    'shopify:section:load',
    setupDurationSwitcher
  );

})();
